import request from '@/utils/request'

// 询价管理列表
export function listByKf(query) {
    return request({
        url: '/pc-api/inquiry/listByKf',
        method: 'get',
        params: query
    })
}

// 登录客服本人可处理的询价提醒（不接受前端指定接收人）
export function getInquiryNotificationCandidates() {
    return request({ url: '/pc-api/inquiry/notificationCandidates', method: 'get' })
}

// 客服认领待审核询价
export function claimInquiry(data) {
    return request({
        url: '/pc-api/inquiry/claim',
        method: 'post',
        data
    })
}

// 查询可接收转单的客服
export function getCustomerServiceUsers() {
    return request({
        url: '/pc-api/inquiry/customerServiceUsers',
        method: 'get'
    })
}

// 将已认领、尚未审核通过的询价转交给其他客服
export function transferCustomerServiceClaim(data) {
    return request({
        url: '/pc-api/inquiry/transferClaim',
        method: 'post',
        data
    })
}

// 定价退回客服的询价列表
export function listPricingReturned(query) {
    return request({
        url: '/pc-api/inquiry/pricingReturn/list',
        method: 'get',
        params: query
    })
}


// 询价管理详情
export function getxjxqs(id) {
  return request({
    url: '/pc-api/inquiry/getKfInfos/' + id,
    method: 'get'
  })
}

// 修改询价详情信息
export function xSEdits(data) {
  return request({
    url: '/pc-api/inquiry/xSEdits',
    method: 'put',
    data: data
  })
}

// 审核通过
export function inquirysh(data) {
    return request({
        url: '/pc-api/inquiry/sh',
        method: 'post',
        data
    })
}

// 退回
export function inquiryth(data) {
    return request({
        url: '/pc-api/inquiry/th',
        method: 'post',
        data
    })
}

// 标记无法联系客户
export function markCustomerUnreachable(data) {
    return request({
        url: '/pc-api/inquiry/unableContact',
        method: 'post',
        data
    })
}

// 强制退回
export function thByAdmin(data) {
    return request({
        url: '/pc-api/inquiry/thByAdmin',
        method: 'post',
        data
    })
}
